// DWR-616: password managers stay out of Support Access's fields. There's no password anywhere in the app
// (staff sign in through Microsoft, customers through Sentinel), yet LastPass took fields like "Add by
// email" for a login and inserted its icon into them: an empty <div data-lastpass-icon-root> inside the
// field's grid label, one more row and gap, which pushed the field out of line with its neighbours. Every
// input, textarea and select gets each manager's "not mine" mark, the ones React adds later too.

/** The marks LastPass, 1Password, Bitwarden and Dashlane honour. */
export const FORM_FILL_IGNORE: Readonly<Record<string, string>> = {
  "data-lpignore": "true",
  "data-1p-ignore": "true",
  "data-bwignore": "true",
  "data-form-type": "other",
};

const FIELDS = "input, textarea, select";

/** Marks `el` (when it is a field) and every field inside it. */
export function markFields(el: Element): void {
  const fields = el.matches(FIELDS) ? [el] : [];
  fields.push(...el.querySelectorAll(FIELDS));
  for (const f of fields) {
    for (const [k, v] of Object.entries(FORM_FILL_IGNORE)) if (f.getAttribute(k) !== v) f.setAttribute(k, v);
  }
}

/** Marks the page's fields now and as they are added; returns a stop function. */
export function ignorePasswordManagers(root: Element = document.body): () => void {
  markFields(root);
  const observer = new MutationObserver((records) => {
    for (const r of records) for (const n of r.addedNodes) if (n instanceof Element) markFields(n);
  });
  observer.observe(root, { childList: true, subtree: true });
  return () => observer.disconnect();
}
